import request from '@/utils/request';

export function getShopCartPage(query) {
  return request({
    url: '/api/system/shopCart/queryShopCartPage',
    method: 'post',
    data: query
  });
}

export function getShopCartList(query) {
  return request({
    url: '/api/system/shopCart/queryShopCartList',
    method: 'post',
    data: query
  });
}

export function updateShopCart(form) {
  return request({
    url: '/api/system/shopCart/updateShopCart',
    method: 'post',
    data: form
  });
}

export function saveShopCart(form) {
  return request({
    url: '/api/system/shopCart/saveShopCart',
    method: 'post',
    data: form
  });
}

export function addShopCart(form) {
  return request({
    url: '/api/system/shopCart/addShopCart',
    method: 'post',
    data: form
  });
}

export function updateCartPrice(form) {
  return request({
    url: '/api/system/shopCart/updateCartPrice',
    method: 'post',
    data: form
  });
}

export function deleteShopCart(id) {
  return request({
    url: '/api/system/shopCart/deleteShopCart',
    method: 'post',
    data: {'id': id}
  });
}

export function getShopCartById(id) {
  return request({
    url: '/api/system/shopCart/getShopCart',
    method: 'post',
    data: {'id': id}
  });
}



// WEBPACK FOOTER //
// ./src/api/cart/index.js